export default __webpack_public_path__ + "static/scroll-down-gif-8780f425bd0a03a63675644ed03de1d3.gif";